module.exports = __webpack_public_path__ + "img/FF_Asset_Info_Web_4.88835e67.png";